// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrentRole_wrapper__W3jbH","avatar":"CurrentRole_avatar__jvCG4","info":"CurrentRole_info__Ci5MQ"};